import React from 'react'
import Navbar from '../components/Navbar'
import ContactComponent from '../components/Contact'
import Scroll from '../components/Utils'

const Contact = () => {
    return (
        <>
            <Scroll />
            <Navbar />
            <ContactComponent />
        </>
    )
}

export default Contact